import { Navigate, Outlet } from 'react-router-dom'

import { SplashScreen } from '@/components/feedback/SplashScreen'
import { useAuthStore } from '@/stores/authStore'

/** Rotas só para visitantes (login, redefinição). Autenticado vai para a home. */
export function PublicOnlyRoute() {
  const status = useAuthStore((state) => state.status)

  if (status === 'authenticating') return <SplashScreen />
  if (status === 'authenticated') return <Navigate to="/" replace />

  return <Outlet />
}
